<template>
<span>
    <div class="odr-field">
        <div class="odr-field__control">
            <div class="odr-checkbox">
                <input :id="id"
                       ref="input"
                       type="checkbox"
                       data-options
                       :data-lpignore="!lastpass"
                       :checked="value"
                       :data-qa="dataQa"
                       class="odr-checkbox__input"
                       @focus="() => {$emit('focus')}"
                       @blur="() => {$emit('blur')}"
                       @change="handleChange($event.target.checked)"
                       @keydown.enter="event => {$emit('finished'); event.preventDefault();}">

                <div class="odr-checkbox__control">
                    <svg class="odr-svg" viewBox="0 0 24 24">
                        <path class="odr-checkbox__checkmark"
                              fill="none"
                              stroke="white"
                              d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                    </svg>
                </div>
            </div>
        </div>

        <label class="odr-field__label"
               :class="{
                   'odr-field__label_wrapable': adaptive
               }"
               :for="id">
            <tpl :content="title || placeholder"/>
        </label>
    </div>
    <div v-if="validation_showError && validation_error"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">{{ validation_error }}</div>
</span>
</template>

<script>
import '@/scss/blocks/field.scss';
import '@/scss/blocks/error-message.scss';
import '@/scss/blocks/checkbox.scss';

import validationMixin from '@/utils/mixins/validation';
import focusMixin from '@/utils/mixins/focus';

export default {
    mixins: [validationMixin, focusMixin],
    props: {
        id: {},
        dataQa: {},
        value: {},
        title: {},
        lastpass: {},
        placeholder: {},
        adaptive: {},
    },
    data () {
        return {
            input: !!this.value,
        };
    },
    watch: {
        input () {
            this.validation_changed();
        },
        value () {
            this.input = this.value;
        },
    },
    methods: {
        // focus_focus () {
        //     this.$refs.input.focus();
        // },
        validation_isEmpty () {
            return !this.input;
        },
        handleChange (value) {
            this.input = value;
            this.$emit('input', value);
        },
    },
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
    },
};
</script>
